/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Home_Load_ErrorInputs */



/**
* | output |
* | --- |
* | "Your home page could not be loaded. Please try again." |
*
* @param {Partner_Home_Load_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_home_load_error = /** @type {((inputs?: Partner_Home_Load_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Home_Load_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ihre Startseite konnte nicht geladen werden. Bitte versuchen Sie es erneut.")
	return /** @type {LocalizedString} */ ("Your home page could not be loaded. Please try again.")
});